import { render } from "./Summary.vue?vue&type=template&id=74ef0143"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
script.render = render

export default script